import { useState } from "react";
export function useSearchPending(searchTerm, isFetching) {
  const [appliedSearch, setAppliedSearch] = useState(searchTerm);
  if (!isFetching && searchTerm !== appliedSearch) {
    setAppliedSearch(searchTerm);
  }
  return searchTerm !== appliedSearch;
}